import { cn } from '@/lib/utils'
import type { Skill, SkillCategory } from '@/types'
import { skillCategory } from '@/types'

const pillBase = 'inline-flex h-6 shrink-0 items-center gap-1 rounded-full border px-2.5 text-xs font-medium'

const categoryPillClasses: Record<SkillCategory, string> = {
  System: 'border-info-foreground/40 bg-info text-info-foreground',
  Custom: 'border-success-foreground/40 bg-success text-success-foreground',
}

export function SkillCategoryBadge({ skill }: { skill: Pick<Skill, 'isSystem'> }) {
  const category = skillCategory(skill)
  return <span className={cn(pillBase, categoryPillClasses[category])}>{category}</span>
}

export function SkillVersionBadge({ version }: { version: string }) {
  return <span className={cn(pillBase, 'border-border bg-muted font-mono text-muted-foreground')}>v{version}</span>
}
